<template>
  <div id="partner">
  <div class="team">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.3s">
        <div class="section-title text-center">
          <h1>
            <img class="left_border" src="./img/border.png">{{$t("partner.title")}}<img class="right_border" src="./img/border.png">
          </h1>
          <h3>{{$t("partner.title_text")}}</h3>
        </div>
      </div>
      <div id="team-carousel" class="owl-carousel">
        <div v-for="(partner, key) in partners" :key="key" class="item col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.8s">
          <a target="_blank" :href="partner.url">
          <div class="team-thumb">
            <div class="image-holder">
              <img :src="partner.logo" class="img-responsive img-circle" alt="Lukia">
            </div>
            <h2 class="heading">{{$t(partner.name)}}</h2>
            <p class="description">{{$t(partner.desc)}}</p>
          </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
import '../../static/js/owl.carousel.min.js'
import '../../static/js/wow.min.js'
export default {
  data(){
    return {
      partners : [
        {
          name: "partner.partner2",
          desc: "partner.partner2_text",
          logo: require("./img/logo_5.png"),
          url : "http://www.b1.co"
        },
        {
          name: "partner.partner4",
          desc: "partner.partner4_text",
          logo: require("./img/logo_3.png"),
          url : "https://www.sgs.com/"
        },
        {
          name: "partner.partner1",
          desc: "partner.partner1_text",
          logo: require("./img/logo_1.png"),
          url : "http://meilizhongguo.org"
        },
        {
          name: "partner.partner3",
          desc: "partner.partner3_text",
          logo: require("./img/logo_2.png"),
          url : "https://www.100tal.com/star"
        },
        {
          name: "partner.partner5",
          desc: "partner.partner5_text",
          logo: require("./img/logo_4.png"),
          url : "http://www.mayfoundation.cn"
        },
        {
          name: "partner.partner6",
          desc: "partner.partner6_text",
          logo: require("./img/logo_6.svg"),
          url : "https://gitlab.cn/"
        },
         {
          name: "partner.partner7",
          desc: "partner.partner7_text",
          logo: require("./img/logo_7.png"),
          url : "https://www.gasauniversity.com"
        },
        {
          name: "partner.partner8",
          desc: "partner.partner8_text",
          logo: require("./img/logo_8.jpg"),
          url : "http://www.kxcq.com/"
        }
      ]
    }
  },
	mounted: function() {
		$(document).ready(function() {
      	$("#team-carousel").owlCarousel({
          items : 3,
          itemsDesktop : [1199,3],
          itemsDesktopSmall : [979,3],
          slideSpeed: 300,
          itemsDesktop : [1199,2],
          itemsTablet: [768,1],
          itemsTabletSmall: [985,2],
          itemsMobile : [479,1],
      });
    });
    
	}
}

</script>
<style>
#partner {
  padding-top: 70px;
  margin-top: -70px;
}
.team h2 {
  color: #d5b85f;
  font-size: 1.3rem;
  font-weight: bold;
  letter-spacing: 4px;
  text-transform: uppercase;
}
.section-title {
  padding-top: 12px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-weight: bold;
}
.section-title h1 {
  font-size: 30px;
}
.section-title h3 {
  font-size: 18px;
}
.team {
  background: #f0f0f0;
  /*padding-bottom: 40px;*/
  padding-bottom: 5rem;
  /*height: 80vh;*/
}

.team .item {
  width: 100%;
  display: block;
}

.team .about-thumb {
  background: #ffffff;
  border-radius: 4px;
  padding: 100px;
  position: relative;
}

.team .about-img img {
  border: 8px solid #ffffff;
  position: absolute;
  left: -120px;
  bottom: -325px;
  padding: 12px;
}

.team .team-thumb {
  width: 100%;
  height: 400px;
  margin: 32px 0;
  text-align: center;
  background: #919191;
  border-radius: 4px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.team .team-thumb .image-holder {
  position: relative;
  top: 40px;
  display: inline-block;
  margin-bottom: 40px;
  padding: 10px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.team .team-thumb .heading {
  font-weight: 700;
  position: relative;
  top: 10px;
  -webkit-transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.team .team-thumb:hover {
  background: #304352;
}

.team .team-thumb:hover .image-holder {
  top: -40px;
  margin-bottom: 0px;
}

.team .team-thumb:hover .heading {
  top: -10px;
}

.team .team-thumb .description {
  font-size: 15px;
  width: 80%;
  margin: 0 auto;
  opacity: 0;
  -webkit-transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: all 600ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
}

.team .team-thumb:hover .description {
  opacity: 1;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.team .team-thumb:hover p.description {
  color: #ffffff;
}

.left_border {
    display: inline-block;
    width: 60px;
    margin-right: 50px;
}
.right_border {
    display: inline-block;
    width: 60px;
    margin-left: 40px;
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
}

@media (max-width: 980px) {
  .team .team-thumb {
    margin-top: 32px;
  }

}

@media (max-width: 767px) {

  .team .about-thumb {
    padding: 32px;
    margin-bottom: 32px;
    text-align: center;
  }

  .team .col-md-3 img {
    position: relative;
    top: 0;
    left: 0;
  }

}

@media (max-width: 650px) {

  h1 {
    font-size: 1.6rem;
  }

  p {
    font-size: 18px;
  }
 
  .team {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .section-title  {
    padding:0px;
    margin: 0px;
  }
  .section-title h3 {
    padding:0;
    margin: 0;
    font-size: 10px;
  }
  .left_border,.right_border {
    display: none;
  }
}

.image-holder img {
  min-width: 220px;
}
</style>


// WEBPACK FOOTER //
// src/components/partner.vue